import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { Lock, Eye, EyeSlash } from 'react-bootstrap-icons'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import Modal from '../../../../../Modal/Modal'

const FIELDS = [
  { key: 'due_date', label: 'Due Date', locked: true },
  { key: 'upload', label: 'Asset Upload', locked: true },
  { key: 'caption', label: 'Caption' },
  { key: 'links_notes', label: 'Links / Notes' },
  { key: 'co_author', label: 'Co-author allowed' },
  { key: 'checklist', label: 'Checklist' },
]

export default observer(function SetupActionModal({ actionDraft, isOpen, onClose }) {
  const { id, action_id } = useParams()
  const [enabledFields, setEnabledFields] = useState(actionDraft.enabled_fields)

  // Re-seed from the real committed state on every open - this modal stays
  // mounted across action switches, so without this it would keep showing
  // whichever action's fields were loaded first.
  useEffect(() => {
    if (isOpen) setEnabledFields(actionDraft.enabled_fields)
  }, [isOpen, actionDraft])

  const toggleField = (key) => {
    setEnabledFields({ ...enabledFields, [key]: !enabledFields[key] })
  }

  const save = () => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/actions/${action_id}/action_draft`, { action_draft: { enabled_fields: enabledFields } })
      .then(updated => {
        actionDraft.enabled_fields = updated.enabled_fields
        toastSuccess('Action settings saved')
        onClose()
      })
      .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>Setup Action</Modal.Header>
      <Modal.Body>
        {FIELDS.map(({ key, label, locked }) => (
          <div key={key} className="flex font-semibold items-center justify-between py-2 border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter last:border-none w-96">
            <span className="dark:text-white">{label}</span>
            <button
              disabled={locked}
              onClick={() => toggleField(key)}
              className={`flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg border-1 ${
                locked
                  ? 'border-rb-widget-border dark:border-rb-dark-mode-lighter text-rb-mat-grey cursor-not-allowed'
                  : enabledFields[key]
                    ? 'border-rb-green text-rb-green'
                    : 'border-rb-widget-border dark:border-rb-dark-mode-lighter text-rb-mat-grey'
              }`}
            >
              {locked ? <Lock /> : enabledFields[key] ? <Eye /> : <EyeSlash />}
              Visible
            </button>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-between w-full">
          <button onClick={onClose} className="rb-btn-cancel px-4 py-2 text-sm font-medium">Cancel</button>
          <button onClick={save} className="px-4 py-2 text-sm font-medium text-white bg-rb-green rounded-lg">Save changes</button>
        </div>
      </Modal.Footer>
    </Modal>
  )
})
